(() => {
  function initHero(root) {
    if (!root || root.dataset.ziHeroReady === 'true') return;

    const track = root.querySelector('[data-zi-hero-track]');
    const slides = Array.from(root.querySelectorAll('[data-zi-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-zi-hero-dot]'));
    const prevBtn = root.querySelector('[data-zi-hero-prev]');
    const nextBtn = root.querySelector('[data-zi-hero-next]');

    if (!track || slides.length < 2) {
      root.dataset.ziHeroReady = 'true';
      return;
    }

    let index = 0;
    let timer = null;
    const autoplay = root.dataset.autoplay === 'true';
    const speed = Number(root.dataset.speed || 5000);

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const next = () => goTo(index + 1);
    const prev = () => goTo(index - 1);

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      if (!autoplay) return;
      timer = setInterval(next, speed);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.dataset.index || 0));
        start();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prev();
        start();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        next();
        start();
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    goTo(0);
    start();
    root.dataset.ziHeroReady = 'true';
  }

  const boot = () => {
    document.querySelectorAll('[data-zi-hero]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const hero = event.target.querySelector('[data-zi-hero]');
    if (hero) {
      hero.dataset.ziHeroReady = 'false';
      initHero(hero);
    }
  });
})();
